import { useMemo } from 'react'

import { ISortSelectOption } from 'src/components/filter/types/filter.types'
import { useQuantityTypeCategories } from '../quantity-type-categories'
import { defaultSelect } from 'src/constants'

const useCategoriesSelectionOption = () => {
  const { data: categories } = useQuantityTypeCategories()

  const items = useMemo(() => {
    const selectionValues: ISortSelectOption[] = categories?.data
      ? categories?.data.map((category) => ({
          label: category.name,
          value: category.id,
        }))
      : []

    selectionValues.unshift(defaultSelect)

    return selectionValues
  }, [categories])

  return { selectName: 'category-input-label.v', queryParamName: 'category', items }
}

export { useCategoriesSelectionOption }
